import React, { Component } from 'react';
import { Row, Col, Button, Image, Glyphicon, Nav, NavItem } from 'react-bootstrap';
import defaultImg from '../../../images/cr-logo-new.png'
import { Link, LinkContainer } from 'react-router-bootstrap'
import Api from '../../Global/Modules/Api'

class MijnCrData extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleClickVerk = this.handleClickVerk.bind(this);
        this.state = {
            member: [],
            member2: {
            },
            header: {
            }
        }
    }
    componentWillMount() {
        var url = "api/members/report";
        Api.GetApi(url).then(data => {
            this.setState({ member: data.member })
            var url = "api/members/" + data.member.id;
            Api.GetApi(url).then(data => {
                this.setState({ member2: data })
                this.setState({ header: data.header })
            });
        });

    }

    handleClick(e) {
        var url = "api/members/" + this.state.member.id + "/pdf";
        Api.GetApiDownload(url)
    }

    handleClickVerk(e) {
        var url = "api/members/" + this.state.member.id + "/verklaringen";
        Api.GetApiDownload(url)
    }
    render() {
        let member = this.state.member
        let completeName = member ? `${member.title} ${member.initials} ${member.firstName} ${member.middleName} ${member.lastName}` : null
        return (
            <div>
                <Row>
                    <Col md={4}>
                        <h4><strong>Welkom {completeName}</strong></h4>
                    </Col>
                    <Col md={5}>
                        <Row>
                            <Col md={7}>
                                Status: {member.status} <br />
                                Lidnummer: {this.state.member2.idOld}<br />
                                Kennis: {this.state.member2.ke}<br />
                                Permanente kennis: {this.state.member2.pe}<br />
                                Totaal Ke's: {this.state.member2.ke + this.state.member2.pe}<br />
                                Gem. aantal uren per jaar: {this.state.member2.hoursPerYear}<br />
                                Ee's acc: {this.state.member2.eeImplemented}<br />
                                Ee's ingevoerd: {this.state.member2.ee}<br />
                                Ingeschreven sinds: {this.state.member2.dateRegister == "0001-01-01T00:00:00" ? "" : Api.formatDate(this.state.member2.dateRegister)}<br />
                                {member.status == "Aspirant" ? "" : "Controle PE: " + member.controle}<br />
                                <LinkContainer to="/account/beheren"><Button>Account beheren</Button></LinkContainer>
                            </Col>
                            <Col md={5}>
                                <Image src={defaultImg} alt="Foto vd RC/RO" responsive thumbnail />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <LinkContainer to="/account/indienen">
                            <Button block bsSize="large">
                                <Glyphicon glyph="download-alt" /> Aanvraag indienen
                            </Button>
                        </LinkContainer>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={4}>
                        <strong>{member.status == "Aspirant" || member.status == "Afgewezen" || member.status == "Nonactief" ? "Kennis toevoegen" : "Permanente educatie toevoegen"}</strong>
                        <Nav bsStyle="pills" stacked>
                            <LinkContainer exact to="/kennis/cursus/toevoegen">
                                <NavItem>Cursus</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/incompany-cursus/toevoegen">
                                <NavItem>Incompany cursus</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/bijeenkomst/toevoegen">
                                <NavItem>Bijeenkomst</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/docentschap/kiezen">
                                <NavItem>Docentschap</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/publicaties/toevoegen">
                                <NavItem>Publicatie</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/lidmaatschap/kiezen">
                                <NavItem>Lidmaatschap</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/voordracht/toevoegen">
                                <NavItem>Voordracht</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/kennis/incompany-kennisoverdracht/toevoegen">
                                <NavItem>Incompany kennisoverdracht</NavItem>
                            </LinkContainer>
                        </Nav>
                    </Col>
                    <Col md={4}>
                        <strong>{member.status == "Aspirant" || member.status == "Afgewezen" || member.status == "Nonactief" ? "Werkervaring" : "Doorlopende werkervaring"}</strong>
                        <Nav bsStyle="pills" stacked>
                            <LinkContainer exact to="#" onClick={this.handleClickVerk}>
                                <NavItem>Download verklaring doorlopende werkervaring</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/werkervaring/beheren">
                                <NavItem>Verklaring doorlopende werkervaring toevoegen</NavItem>
                            </LinkContainer>
                        </Nav>
                        <br /><br />
                        <strong>Doorgroei</strong>
                        <Nav bsStyle="pills" stacked>
                            <LinkContainer exact to="/werkervaring/beheren">
                                <NavItem>Werkervaring toevoegen</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/werkervaring/referenties">
                                <NavItem>Referenties beheren</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/werkervaring/controle">
                                <NavItem>Stuur referenties een controle e-mail</NavItem>
                            </LinkContainer>
                            <LinkContainer exact to="/account/indienen">
                                <NavItem>Toetsingsaanvraag indienen</NavItem>
                            </LinkContainer>
                        </Nav>
                        <br /><br />
                    </Col>
                    <Col md={4}>
                        <strong>Rapport</strong>
                        <br /><br />
                        <Button block bsSize="large" onClick={this.handleClick}>
                            <br />
                            <Glyphicon glyph="signal" /> Rapport
                            <br />
                            <br />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <LinkContainer to="/kennis/beheren">
                            <Button block>
                                Overzicht PE
                            </Button>
                        </LinkContainer>
                    </Col>
                    <Col md={4}>
                        <LinkContainer to="/werkervaring/beheren">
                            <Button block>
                                Overzicht werkervaring
                            </Button>
                        </LinkContainer>
                    </Col>
                    <Col md={4}>
                        <LinkContainer to="/rapport/bekijken">
                            <Button block >
                                Bekijk rapport
                            </Button>
                        </LinkContainer>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default MijnCrData;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/MijnCR.js